import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Has your sales leader gone mad?" />

                      
<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/has-your-sales-leader-gone-mad/&amp;title=Has%20your%20sales%20leader%20gone%20mad%3F&amp;summary=Has%20your%20sales%20leader%20gone%20mad%3F&amp;source=https%3A//salestribe.com/knowledge-centre/insights/has-your-sales-leader-gone-mad/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Has%20your%20sales%20leader%20gone%20mad%3F&amp;url=https%3A//salestribe.com/knowledge-centre/insights/has-your-sales-leader-gone-mad/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/has-your-sales-leader-gone-mad/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/has-your-sales-leader-gone-mad/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Has%20your%20sales%20leader%20gone%20mad%3F&amp;body=https%3A//salestribe.com/knowledge-centre/insights/has-your-sales-leader-gone-mad/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-challenge-boss.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>Has your sales leader gone mad?</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>14 September 2016</li>
                        <li>4 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Is your sales leader barking mad? Or are they just ignoring the facts?</h3>

<div className="rich-text"><p>Sales leaders seem to be ignoring some very obvious trends that are now occurring in the business world. When it comes to operating a B2B sales force, you could be forgiven for thinking that sales leaders have all gone mad? Or are they simply too busy to see what's happening around them? </p><p>Lets ponder the following: </p><ul><li><strong>Average sales cycle times </strong>are increasing – it’s universally accepted that sales cycles are now getting longer with 'consensus buying' being the new norm. That is, 6.8 buyers for each purchase decision (CEB), and more scrutiny from procurement departments on every deal. <em>Agreed!</em></li><li><strong>Tenure</strong> - “The average tenure of a B2B sales person is 1.4 years (or 16.8 months), while less than 5% of sales people stay on board for more than 3 years" (Sales Metrics Report 2016). <em>Yep, sounds about right to me!</em></li><li><strong>On-boarding</strong> – 'sales ramp-up' (that is, 'time to bring a new hire to full productivity') is now much longer than ever before and this is an indictment on sales leaders. According to a recent study by CSO Insights 60.7% of the study participants reported a ramp-up time of seven months or more. 18.1% stating the ramp-up time is 1 year. <em>What the? </em></li></ul><p>OK, so let’s just pause and attempt to make sense of some of these above-mentioned trends: so, more stakeholders and longer sales cycles - with averages (specifically in B2B technology sectors) said to be ranging from 6-12 months. And the average sales person only lasts about 16 months in their role which means that in many cases they barely get enough time for 2 - 3 sales cycles. But hang on – according to CSO Insights, it's taking 60.7% of these same sales people more than 7 months to ramp up to full productivity. Therefore, <strong>the majority of sales people have about 11 months of effective selling time before they are off to their next job</strong>. <em>What the? </em></p><p>If this scenario sounds about right for your business then one can only conclude that your sales leader (and possibly your HR Manager) has gone mad. Seriously, against this backdrop, is it really any great surprise that business leaders are having such a hard time building sustainability and predictability into their businesses? Are you surprised at the declining returns from your investment in the sales function? No surprise that almost every sales leader that I know is now complaining about: declining conversion rates, dwindling pipeline and horrendous staff attrition (among other things).</p><p>If you are currently working in a sales role then I do honestly feel for you. These current trends mean that the odds are increasingly stacked against you being successful. Sales was always a tough gig, but now it's almost a case of whether you are lucky enough to be in the <em>right place, at the right time</em> that will ultimately decide if you are successful or not. The truth is that there is so much that is outside of the control of the average sales person these days that it's a role that is quite often unforgiving</p><p>So what are the root causes of these current day issues as described above? Let’s consider 5 simple and irrefutable concepts:</p><ul><li>In the past, a vendor sales person offered value to buyers through the process of sharing <strong>information</strong> that would help solve the buyer's problem and also result in a sale for the vendor. This was information that buyers did not possess. Search engines (Google) and social media has reversed that dynamic by providing buyers with access to all of the information that they could ever require to solve their own problems without needing to speak to the once all-knowing sales person.</li><li>We now operate in a globalized world where <strong>mature markets </strong>mean educated buyers and commodification of products. Barriers to entry are low, with increased global competition resulting in downward pressure on pricing and margins. The increasing speed of innovation also means that product life-cycles are getting shorter and shorter. Business velocity is at unprecedented levels. </li><li>Today, if sales people are not seen as “<strong>adding value</strong>” — that is, being a source of specialist (not general) knowledge about how buyers can tackle a problem, or examples of how other customers have realized value — then the likelihood of securing appointments with prospective buyers is zero when buyers are already time poor.</li><li>Buyers are desperately looking for any means by which to drive costs down, and most businesses are now trying to<strong> rationalize vendors.</strong> That means doing “more business with less vendors”. As a result, there are very few wide open ‘greenfield’ markets….on the contrary, if you are not an existing supplier then your ability to attain <em>net new</em> customers is increasingly limited….even your existing customers would like to find a way to cull you.</li><li>Buyers now complete between 60-80% of the buying journey before talking with a vendor sales person. Customers are educated and self-directed and are looking to <strong>self-serve</strong> wherever possible - actively avoiding talking with a biased sales person, whom they know, has a vested interest in recommending a course of action that also benefits them. </li></ul><p>These 5 x trends or concepts are no doubt contributing to the increasingly long sales cycles, high levels of sales staff attrition, and the increasing % or sales people that are NOT meeting quota. </p><p>If your sales leader is ignoring these trends, or simply too busy to actually zoom out and see what’s going on, you had better call 'time-out' and reassess your go-to-market approach. </p><p>By the way, I am by no means a blind follower of statistics. As Mark Twain said, t<em>here are three kinds of lies: lies, damned lies and statistics.</em> However, these above-mentioned stats and trends are almost 100% congruent with my own recent experience working with B2B sales departments, and I’m not trying to argue any particular point here. I’m yet again simply attempting to shine a light on some of the madness that exists in the sales space right now.</p><p>Of one thing I’m certain, if your sales leader is running the same old approach to sales in this modern business context then you might want to check his/her mental state. Has your sales leader gone mad?</p><p>I would love to hear your thoughts on this topic. Please let me know if you agree or disagree?</p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/has-your-sales-leader-gone-mad/&amp;title=Has%20your%20sales%20leader%20gone%20mad%3F&amp;summary=Has%20your%20sales%20leader%20gone%20mad%3F&amp;source=https%3A//salestribe.com/knowledge-centre/insights/has-your-sales-leader-gone-mad/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Has%20your%20sales%20leader%20gone%20mad%3F&amp;url=https%3A//salestribe.com/knowledge-centre/insights/has-your-sales-leader-gone-mad/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/has-your-sales-leader-gone-mad/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/has-your-sales-leader-gone-mad/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Has%20your%20sales%20leader%20gone%20mad%3F&amp;body=https%3A//salestribe.com/knowledge-centre/insights/has-your-sales-leader-gone-mad/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>
      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 